import { Card, Center, ScrollArea, Table, Text } from "@mantine/core";
import { useEffect, useState } from "react";

export function ScheduleTable(props: { events: any }) {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (props.events) {
            setRows(props.events.map((e: any) =>
                <Table.Tr key={e.date}>
                    <Table.Td>{e.date}</Table.Td>
                    <Table.Td>{e.time}</Table.Td>
                    <Table.Td>{e.location}</Table.Td>
                    <Table.Td>{e.note}</Table.Td>
                </Table.Tr>
            ))
        }
    }, [props])

    return <Table>
        <Table.Thead>
            <Table.Tr>
                <Table.Th w={200}>Date</Table.Th>
                <Table.Th w={150}>Time</Table.Th>
                <Table.Th w={300}>Location</Table.Th>
                <Table.Th></Table.Th>
            </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
    </Table>
}
export function ScheduleCard(props: { season: number, events: any }) {

    return <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Card.Section>
            <Center h={60} bg="var(--mantine-color-gray-light)">
                <Text fw={800} >{props.season} Schedule</Text>
            </Center>
        </Card.Section>
        <ScrollArea style={{ overflowY: "auto" }}>
            <ScheduleTable events={props.events} />
        </ScrollArea>
    </Card>
}

